import { Box, Button, Dialog, DialogActions, DialogTitle } from "@mui/material";
import type { FC } from "react";
import { useState } from "react";
import toast from "react-hot-toast";
import { useSupabaseCallback } from "../../server/supabase/hooks";
import { SupabaseTagsService } from "./server/supabase-tags-service";
import type { Tag } from "./types";

export const TagDeleteDialog: FC<{
  open: boolean;
  handleClose: () => void;
  tag?: Tag;
  reload: () => void;
}> = ({ open, handleClose, tag, reload }) => {
  const [saving, setSaving] = useState(false);

  const handleDelete = useSupabaseCallback(
    async ({ supabase }) => {
      if (saving || !tag) return;
      setSaving(true);

      const { error } = await new SupabaseTagsService(supabase).deleteTag(tag.id);
      setSaving(false);

      if (error) {
        toast.error("Deleting tag failed, please try again");
        return;
      }

      toast.success("Tag deleted");
      reload();
      handleClose();
    },
    [handleClose, reload, saving, tag],
  );

  const onDeleteClick = (): void => {
    void handleDelete();
  };

  if (!tag) return null;

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        <Box>Delete {tag.name} Tag</Box>
      </DialogTitle>
      <DialogActions>
        <Button onClick={handleClose} data-analytics-id="delete-tag-cancel" variant="text">
          Cancel
        </Button>
        <Button
          onClick={onDeleteClick}
          data-analytics-id="delete-tag"
          variant="text"
          loading={saving}
          disabled={saving}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};
